import { Component } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-checklist-report-save-filter-dialog',
    templateUrl: './checklist-report-save-filter-dialog.component.html',
    standalone: false,
})
export class FiChecklistReportSaveFilterDialogComponent extends FiDialogsContentBase<void, string> {
    name: string = '';

    getResult() {
        return this.name;
    }

    isYesButtonDisabled() {
        return !this.name || this.name.length < 1;
    }
}
